import { DivIcon, PointExpression } from "leaflet";
import { renderToString } from "react-dom/server";

import { LayerAlias, PointClassificationsNames } from "constant";

import IconButton from "components/buttons/IconButton/IconButton";
import MapMarkerIcon from "../MapMarkerIcon/MapMarkerIcon";
import MapSensorFusionMarkerIcon from "../MapSensorFusionMarkerIcon/MapSensorFusionMarkerIcon";

import CancelIcon from "assets/icons/cancel.svg";
import CheckIcon from "assets/icons/check.svg";
import MoveIcon from "assets/icons/move-white.svg";

interface MapDraggableMarkerIconProps {
  marker: any;
  markerNumber: number;
  activeMarkerId: string | null;
  draggableId: string | null;
  color: string;
}

const MapDraggableMarkerIcon = ({
  marker,
  markerNumber,
  activeMarkerId,
  draggableId,
  color
}: MapDraggableMarkerIconProps): DivIcon => {
  const iconSize: PointExpression = [2, 17];
  const iconAnchor: PointExpression = [1, 18];

  const markerName = `${
    PointClassificationsNames[marker.additional.classification.alias]
  }_${markerNumber}`;

  const html = renderToString(
    <div>
      {draggableId === marker.id && (
        <>
          <img
            className="marker-move-icon"
            src={MoveIcon}
            alt=""
            style={{ top: 4, left: -15 }}
          />
          <div className="marker-options">
            <div id="marker-check" className="marker-button">
              <IconButton icon={CheckIcon} alt={""} />
            </div>
            <div id="marker-cancel" className="marker-button">
              <IconButton icon={CancelIcon} alt={""} />
            </div>
          </div>
        </>
      )}
      <div style={{ opacity: draggableId === marker.id ? 0.7 : 1 }}>
        {marker.layerAlias === LayerAlias.SENSOR_FUSION ? (
          <MapSensorFusionMarkerIcon
            color={color}
            sensorFusion={marker.additional}
            probability={marker.additional.probability}
            markerName={markerName}
            isActive={activeMarkerId === marker.id}
          />
        ) : (
          <MapMarkerIcon
            color={color}
            probability={
              marker.layerAlias === LayerAlias.MANUAL
                ? "manual"
                : marker.additional.probability
            }
            markerName={markerName}
            isActive={activeMarkerId === marker.id}
          />
        )}
      </div>
    </div>
  );

  return new DivIcon({
    html,
    className: "marker-reset",
    iconSize,
    iconAnchor
  });
};

export default MapDraggableMarkerIcon;
